import { defa } from 'defa-object';
import ClusterModel    from 'scripts/poppet/cluster-model';

/**
 * defa.models.PowerConfiguration
 * The DEFA PowerConfiguration model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	powerconfig: '/homeAutomation/powerConfiguration?attrs=',
};

const PowerConfiguration = ClusterModel.extend( {
	url: function() {
		return api.linkcom + this.get('id') + api.powerconfig + this.getAttributes();
	},
	
	onError: function (model, response, options) {
		let models = this._getModels();
		for (let index in models ) {
			models[index].trigger('error', model, response, options);
		}
	},
	
	_getModels: function() {
		let id = this.get('id');
		return [
			channel.request('batteryAlerts').get(id),
			channel.request('powerAlerts').get(id),
		];
	},
	
});

export default PowerConfiguration;
